<template>
	<div id="bottomLeft">
		<div class="bg-color-black">
			<div class="d-flex pt-2 pl-2" style="padding:0.3rem 0 0 0.3rem">
				<span style="color:#5cd9e8">
					<icon name="chart-line"></icon>
				</span>
				<div class="d-flex">
					<span class="fs-xl text mx-2">设备信息</span>
					<dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
				</div>
			</div>
			<div>
				<div style="width:5.4rem;height:3.4rem;">
					<div class="detail_head">
						<span class="head">设备名称：</span>
						<span class="desc">{{info.device_name}}</span>
						<div class="detail_head">
							<span class="head">外接传感器数量：</span>
							<span class="desc">{{info.device_sensors}}</span>
						</div>
						<div class="detail_head">
							<span class="head">子板传感器数量：</span>
							<span class="desc">{{info.device_extends}}</span>
						</div>
						<div class="detail_head">
							<span class="head">仓内主机号：</span>
							<span class="desc">{{info.pc_id}}</span>
						</div>
						<div class="detail_head">
							<span class="head">imei：</span>
							<span class="desc">{{info.imei}}</span>
						</div>
						<div class="detail_head">
							<span class="head">投运时间：</span>
							<span class="desc">{{info.device_state_time}}</span>
						</div>
						<div class="detail_head">
							<span class="head">最新数据更新时间：</span>
							<span class="desc">{{info.newtime}}</span>
						</div>
						<div class="detail_head">
							<span class="head">状态：</span>
							<span class="desc">{{info.isrest_text}}</span>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	export default {
		data() {
			return {

			};
		},
		mixins: [echartMixins],
		props: {
			info: Object
		},
		methods: {

		}
	};
</script>

<style lang="scss">
	.detail_head {
		margin: 0.18rem 0 0 0.3rem;
		font-size: 0.22rem;
		color: #5cd9e8;
	}

	.detail_head .desc {
		font-weight: bold;
	}
</style>